import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export type TemplateMessageTypeFocusBreadcrumb = {
  label: string;
  link?: string;
  isActive?: boolean;
};

export const useTemplateMessageTypeFocusPage = () => {
  const location = useLocation();
  const selectedDealer = useSelector(selectDealerSelected);

  const breadcrumbsList = useMemo((): TemplateMessageTypeFocusBreadcrumb[] => {
    const fromState = (
      location.state as
        | { breadcrumbsList?: TemplateMessageTypeFocusBreadcrumb[] }
        | null
    )?.breadcrumbsList;
    if (fromState?.length) {
      return fromState;
    }
    return [{ label: 'Segment Message Type Focus', isActive: true }];
  }, [location.state]);

  const hasDealer = hasDealerContext(selectedDealer);
  const dealerObj =
    typeof selectedDealer === 'object' && selectedDealer !== null
      ? (selectedDealer as { site_title?: string; dealer?: string; _id?: string })
      : null;
  const dealerTitle = dealerObj?.site_title;
  const dealerId = dealerObj?.dealer || dealerObj?._id;

  return {
    breadcrumbsList,
    hasDealer,
    dealerTitle,
    dealerId,
  };
};
